module.exports = __webpack_public_path__ + "static/dataManagement-32ed126fdaa39a296f1932c6bb6bc305.gif";